<template>
    <b-form-group
        :label="$t('targets.targetTypes')"
        label-for="targetTypeSelect"
    >
        <multiselect
            id="targetTypeSelect"
            :state="state"
            @changeValue="$emit('update:value', $event)"
            :options="targetOptions"
            :hide-selected="true"
            label="title"
        >
            <template slot="c-option" slot-scope="{ options: { option } }">
                <span>{{ option.label }}</span>
            </template>
        </multiselect>
    </b-form-group>
</template>

<script>
import { Multiselect } from '@/views/components/selects'
import defaultTargetTypeOptions from '@/data/target-types'

export default {
    name: 'TargetTypes',
    components: {
        Multiselect,
    },
    props: ['value', 'state', 'disabled', 'label'],
    data() {
        return {
            targetOptions: defaultTargetTypeOptions,
        }
    },
}
</script>
